import React from 'react'
import { Card, CardContent } from '@mui/material'
import { NutrisenseLogo } from 'components'
import {
  ImmersiveLogoStyled,
  ImmersiveScreenContainerStyled,
  ImmersiveScreenScrollStyled
} from './styles'

interface IImmersiveScreen {
  children: React.ReactNode
}

export const ImmersiveScreen = ({ children }: IImmersiveScreen) => {
  return (
    <ImmersiveScreenScrollStyled>
      <ImmersiveScreenContainerStyled>
        <Card sx={{ width: '100%', maxWidth: 500, flexShrink: 0 }}>
          <CardContent>
            <ImmersiveLogoStyled>
              <NutrisenseLogo />
            </ImmersiveLogoStyled>
            {children}
          </CardContent>
        </Card>
      </ImmersiveScreenContainerStyled>
    </ImmersiveScreenScrollStyled>
  )
}
